import React from "react";
import FiberStrands from "@/components/FiberStrands";

// Fiber-optic underline for section headings, matching the Hero accent.
export default function FiberUnderline({ center = false, className = "" }) {
  return (
    <div className={`mt-4 h-5 w-52 sm:h-6 sm:w-72 ${center ? "mx-auto" : ""} ${className}`}>
      <FiberStrands className="h-full w-full" />
    </div>
  );
}
